<template>
  <div class="modal modal-blur fade" id="modal-add-social-site" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add Manual Social Site</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"/><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
        </button>
      </div>
      <div class="modal-body" v-show="loading">
        Loading... <img src="../assets/ajax-loader.gif" />
      </div>
      
      <div class="modal-body" v-show="!loading">
        <!-- <ul class="nav nav-tabs">
          <li class="nav-item">
            <a :class="{ 'nav-link': true, 'active': tab == 'bulkadd' }" aria-current="page" href="#" @click.prevent="tab = 'bulkadd'">Bulk Add</a>
          </li>
          <li class="nav-item">
            <a :class="{ 'nav-link': true, 'active': tab == 'singlesite' }" href="#" @click.prevent="tab = 'singlesite'">Single Site</a>
          </li>
        </ul> -->
        
        <div v-if="tab=='bulkadd'">
          <div class="mb-3">
            <label class="form-label">Site List</label>
            <textarea rows="15" style="width: 100%;" v-model="bulkSites"></textarea>
            
            <p v-for="bulkError in bulkErrors" class="text-danger">{{bulkError}}</p>
          </div>
          
          <div class="mb-3">
            <label class="form-label">Created On</label>
            <input type="date" class="form-control" placeholder="Created On" v-model="bulkCreatedAt">
          </div>
          
          <div>
            <a href="#" class="btn btn-link link-secondary" data-dismiss="modal">
              Cancel
            </a>
            <a @click.prevent="onBulkAddSocialSite" href="#" class="btn btn-primary ml-auto">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"/><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              Add Social Sites
            </a>
          </div>
        </div>
        
        <div v-if="tab=='singlesite'">
          <div>Single site adding has been disabled until auto web 2.0 creation is re-enabled. Please enter a single site in the Bulk URL page. Thank you.</div>
          
          <!-- <div class="mb-3">
            <label class="form-label">Site</label>
            <input type="text" required class="form-control" placeholder="Site" v-model="site">
          </div>
          <div class="mb-3">
            <label class="form-label">Email</label>
            <input type="text" class="form-control" placeholder="Email" v-model="email">
          </div>
          <div class="mb-3">
            <label class="form-label">Username</label>
            <input type="text" class="form-control" placeholder="Username" v-model="username">
          </div>
          <div class="mb-3">
            <label class="form-label">Password</label>
            <input type="password" class="form-control" placeholder="Password" v-model="password">
          </div>
          <div class="mb-3">
            <label class="form-label">URL</label>
            <input type="text" class="form-control" placeholder="URL" v-model="url">
          </div>
          <div class="mb-3">
            <label class="form-label">Keyword</label>
            <select class="form-control" v-model="keyword">
              <option value="">Not Selected</option>
              <option v-for="keyword in keywords" :value="keyword">{{keyword}}</option>
            </select>
          </div>
          <div class="mb-3">
            <label class="form-label">Created On</label>
            <input type="date" class="form-control" placeholder="Created On" v-model="createdAt">
          </div>
          
          <div>
            <a href="#" class="btn btn-link link-secondary" data-dismiss="modal">
              Cancel
            </a>
            <a @click.prevent="onAddSocialSite" href="#" class="btn btn-primary ml-auto">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"/><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              Add Social Site
            </a>
          </div>
          
          -->
        </div>
        
      </div>
    </div>
  </div>
 </div>
</template>

<script>
  import $ from 'jquery';
  import WebLLCRESTApi from "../api/api";

  export default {
    name: "AddSocialSite",
    
    data() {
      return {
        site: "",
        email: "",
        username: "",
        password: "",
        url: "",
        keyword: "",
        createdAt: "",
        bulkSites: "",
        bulkCreatedAt: "",
        tab: "bulkadd",
        loading: false,
        
        bulkErrors: [],
        keywords: []
      }
    },
    props: {
      clientId: String,
      refreshId: String,
    },
    methods: {
      async onAddSocialSite() {
        var api = new WebLLCRESTApi("Client-Pages");
        
        var newSocialSite = {
          url: this.url,
          category: "socialprofile",
          linkType: "positive",
          hasLogin: false,
          createdAt: (this.createdAt ? this.createdAt + "T00:00:00Z" : new Date().toISOString()),
          clientId: this.clientId
        };
        
        var res = await api.addData(newSocialSite);
        var json = await res.json();
        
        this.$emit('added', json.id);
        $('#modal-add-social-site').modal('toggle');
      },
      
      async onBulkAddSocialSite() {
        var api = new WebLLCRESTApi("Client-Pages");
        
        this.loading = true;
        const lines = this.bulkSites.split("\n");
        
        // lets make sure there are no errors with any of them first
        this.bulkErrors = lines.filter((siteURL) => {
          try {
            new URL(siteURL.trim());
            return false;
          }
          catch(e) {
            return true;
          }
        }).map((siteURL) => {
          return siteURL.trim() + " is not a valid URL";
        });
        
        // add the sites now
        if(this.bulkErrors.length == 0) {
          for(var index=0; index<lines.length; index++) {
            const siteURL = lines[index].trim();
            
            if(siteURL) {
              var newSocialSite = {
                url: siteURL,
                category: "socialprofile",
                linkType: "positive",
                hasLogin: false,
                createdAt: (this.bulkCreatedAt ? this.bulkCreatedAt + "T00:00:00Z" : new Date().toISOString()),
                clientId: this.clientId
              };
              
              const res = await api.addData(newSocialSite);
              if(res.status < 400) {
                const json = await res.json();
              }
              else {
                const json = await res.json();
                alert(JSON.stringify(json));
              }
            }
          }
          
          this.loading = false;
          this.$emit('added', "bulkadd");
          $('#modal-add-social-site').modal('toggle');
        }
        else {
          this.loading = false;
        }
      }
    
    },
    
    watch: {
      async refreshId(to, from) {
        if(this.clientId) {
          const api = new WebLLCRESTApi("Campaigns");
          const campaigns = await api.getData(null, {
            "where": {
              "clientId": this.clientId
            }
          });
          
          for(var index=0; index<campaigns.length; index++) {
            const campaign = campaigns[index];
            const tierData = JSON.parse(campaign.data);
            
            if(tierData.keywords) {
              for(var kI=0; kI<tierData.keywords.length; kI++) {
                const keyword = tierData.keywords[kI];
                
                if(typeof keyword == "string") {
                  this.keywords.push(keyword);
                }
                else {
                  this.keywords.push(keyword.str);
                }
              }
            }
          }
          
          this.keywords.sort();
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AddSocialSite.vue